import axios from '@/utils/request'

/**
 * 电子放行列表
 */
const getElectronicList = (params, options) => axios({
  url: 'release',
  params,
  options
})

/**
 * 导出电子放行excel
 */
const getElectronicExcel = params => axios({
  url: 'release/excel',
  responseType: 'arraybuffer',
  params
})

/**
 * 审批人
 */
const getAuditList = (industryUuid) => axios({
  url: `release/audit?industryUuid=${industryUuid}`
})

/**
 * 设置审批人
 */
const setAudit = (data) => axios({
  url: `release/audit?userUuid=${data.userUuid}&industryUuid=${data.industryUuid}`,
  method: 'put'
})

/**
 * 电子放行详情
 */
const ElectronicDetails = (uuid) => axios({
  url: `release/${uuid}`
})

/**
 * 电子放行审核操作
 */
const putElectronic = (data) => axios({
  url: 'release',
  method: 'put',
  data
})

export {
  getElectronicList,
  getElectronicExcel,
  getAuditList,
  ElectronicDetails,
  putElectronic,
  setAudit
}
